<template>
  <section class="container">
    <el-form label-width="100px">
      <el-form-item label="标题">
        <el-input v-model="editObject.experience_title"/>
      </el-form-item>
      <el-form-item label="副标题">
        <el-input v-model="editObject.experience_son_title"/>
      </el-form-item>
      <el-form-item label="描述">
        <el-input
          type="textarea"
          autosize
          v-model="editObject.experience_desc"/>
      </el-form-item>
      <el-form-item label="英文标题">
        <el-input v-model="editObject.experience_english_title"/>
      </el-form-item>
      <el-form-item label="英文副标题">
        <el-input v-model="editObject.experience_english_son_title"/>
      </el-form-item>
      <el-form-item label="英文描述">
        <el-input
          type="textarea"
          autosize
          v-model="editObject.experience_english_desc"/>
      </el-form-item>
      <el-form-item label="图片">
        <el-upload
          class="avatar-uploader"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadSuccess"
          :show-file-list="false">
          <img
            v-if="editObject.experience_img"
            :src="qiniuDomain + editObject.experience_img"
            class="avatar">
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"/>
        </el-upload>
      </el-form-item>

      <el-form-item label="banner">
        <el-upload
          class="upload-demo"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadBannerSuccess"
          :show-file-list="false"
          list-type="picture">
          <el-button
            size="small"
            type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <div
          v-for="(item, index) in editObject.banner"
          :key="index"
          class="banner-box">
          <span
            class="icon"
            @click="onRomoveBanner(index)">×</span>
          <img
            :src="qiniuDomain + item.experience_carousel"
            class="banner-img" >
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSave">保存</el-button>

      </el-form-item>
    </el-form>

  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  addStore, editStore,
} from '@/api/store'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      editObject: { //  根据接口来的命名，不是很喜欢---
        experience_title: '',
        experience_desc: '',
        experience_img: '',
        experience_son_title: '',
        experience_english_title: '',
        experience_english_desc: '',
        experience_english_son_title: '',
        banner: [],
      },
    };
  },

  created() {
    this.network().getQiniuInfo()
  },
  methods: {
    routerTo(url) {
      this.$router.push({
        path: url,
      })
    },
    uploadSuccess(res) {
      this.editObject.experience_img = res.hash
    },
    uploadBannerSuccess(res) {
      const oBanner = {
        experience_carousel: res.hash,
      }
      this.editObject.banner.push(oBanner)
    },
    onRomoveBanner(index) {
      this.editObject.banner.splice(index, 1)
    },
    onSave() {
      if (!this.event().inputVerify()) return
      this.network().addStore()
    },
    event() {
      return {
        inputVerify: () => {
          if (!this.editObject.experience_title) {
            this.$message('请填写标题')
            return false
          }
          if (!this.editObject.experience_son_title) {
            this.$message('请填写副标题')
            return false
          }
          if (!this.editObject.experience_desc) {
            this.$message('请填写描述')
            return false
          }
          if (!this.editObject.experience_english_title) {
            this.$message('请填写英文标题')
            return false
          }
          if (!this.editObject.experience_english_son_title) {
            this.$message('请填写英文副标题')
            return false
          }
          if (!this.editObject.experience_english_desc) {
            this.$message('请填写英文描述')
            return false
          }
          if (!this.editObject.experience_img) {
            this.$message('请上传图片')
            return false
          }
          if (this.editObject.banner.length < 1) {
            this.$message('请上传banner')
            return false
          }
          return true
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        addStore: async () => {
          const { status } = await addStore(this.editObject)
          if (status === 200) {
            //  这里要清空数据
            this.$message({
              message: '添加成功',
              type: 'success',
            })
          }
        },
        editStore: async () => {
          const { status } = await editStore(this.editObject)
          if (status === 200) {
            this.$message({
              message: '更新成功',
              type: 'success',
            })
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .banner-box {
    position: relative;
    margin-right: 20px;
    display: inline-block;
    width: 200px;
    height: 100px;
  }
  .banner-box .icon {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    cursor: pointer;
  }
  .banner-img {
    width: 200px;
    height: 100px;
  }
  .el-form {
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/store/add.vue